if (!customElements.get('mrp-complementary-pro')) {
  class MrpComplementaryPro extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-mrp-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-mrp-dot]'));
      this.index = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.mrpDot));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.timer || document.hidden) return;
      const delay = Math.max(Number(this.dataset.delay) || 5000, 2000);
      this.timer = window.setInterval(() => this.show(this.index + 1), delay);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  customElements.define('mrp-complementary-pro', MrpComplementaryPro);
}